import React, { useEffect, useState } from 'react';
import { MdOutlineCancel, MdOutlineSearch, MdPictureAsPdf } from 'react-icons/md';
import './Mi.css'; // Estilos personalizados
import { getManDocuMaqFiltro } from '../../services/ManDocuMaq';
import { getConfigCarpetaMandante } from '../../services/CarpetaDocMandante';

const SearchDocMaquina = ({ proyecto, maquina, onValorSeleccionadoChange, soloObra = false, usarConfigCarpeta = false }) => {
  const [documentos, setDocumentos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  // Cargar documentos desde API cuando se abre el modal
  const fetchDocumentos = async () => {
    try {
      let miDataBusqueda;

      if (usarConfigCarpeta) {
        const config = await getConfigCarpetaMandante(proyecto);
        // Normalizar al mismo formato que getManDocuMaqFiltro para que el consumidor no cambie
        miDataBusqueda = (config || []).map((item) => ({
          _id: item._id,
          idDocuGeneral: item._id,
          documentoGeneral: item.documentoGeneral,
          exigeFecha: item.exigeFecha,
          vigencia: item.vigenciaPersonalizada ?? item.vigencia,
          tipo: 'Logística',
        }));
      } else {
        miDataBusqueda = await getManDocuMaqFiltro(proyecto, maquina, !soloObra, soloObra);
      }

      setDocumentos(miDataBusqueda || []);
      setFilteredDocs(miDataBusqueda || []);
    } catch (error) {
      console.error('Error al obtener documentos:', error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = documentos.filter((doc) =>
      doc.documentoGeneral?.toLowerCase().includes(value)
    );
    setFilteredDocs(filtered);
  };

  const handleSelect = (doc) => {
    onValorSeleccionadoChange(doc);
    setModalOpen(false);
    setSearchTerm('');
    setFilteredDocs([]);
  };  

  const openModal = () => {
    setSearchTerm('');
    setModalOpen(true);
    fetchDocumentos();
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="search-documento">
      <button
        type="button"
        className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold py-2 px-4 rounded shadow"
        onClick={openModal}
      >
        <div className="flex items-center gap-2">
          <MdOutlineSearch />
          Agregar Documento
        </div>
      </button>

      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal bg-white shadow-lg p-6 rounded w-full max-w-2xl mx-auto mt-10 relative">
            <button
              type="button"
              onClick={closeModal}
              className="absolute top-2 right-2 text-xl text-gray-400 hover:text-gray-600"
            >
              <MdOutlineCancel />
            </button>

            <h2 className="text-lg font-semibold mb-4">Buscar Documento Maquina</h2>

            <input
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Escribe parte del nombre del documento..."
              className="w-full border p-2 mb-4 rounded text-sm outline-none focus:ring"
            />

            {filteredDocs.length > 0 ? (
              <ul className="space-y-2 max-h-60 overflow-y-auto">
                {filteredDocs.map((doc) => (
                  <li
                    key={doc._id}
                    className="border p-3 rounded hover:bg-gray-100 cursor-pointer flex items-center gap-4 text-sm"
                    onClick={() => handleSelect(doc)}
                  >
                    <div className="flex flex-col">
                      <span className="text-gray-500 text-xs">{doc.documentoGeneral}</span>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">No hay resultados disponibles.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDocMaquina;